// extracted by mini-css-extract-plugin
export default {"relatedSearchPill":"_7pXn4"};